import { Button, Chip, Divider, Grid, IconButton, Slider, Stack, TextField, Typography } from "@mui/material";
import SelectInput from "../../ui/SelectInput";
import $carbon, { energyContentFuels } from "../../../services/$carbon";
import { useContext, useEffect, useState } from "react";
import { Delete, DocumentScanner, FileOpen, Folder, Photo, Save, UploadFile } from "@mui/icons-material";
import UploadDocumentModal from "../../ui/UploadDocumentModal";
import { DataContext } from "../../DataContext";
import DeleteDocumentModal from "../../ui/DeleteDocumentModal";
import { AppContext } from "../../../AppContext";
import moment from "moment";
import $data from "../../../services/$data";
import CarbonPhotosModal from "../CarbonPhotosModal";

const generateYears = (start) => {
  let years = [start];
  while (parseInt(start) < parseInt(moment().format('YYYY'))) {
    start++;
    years.push(start);
  }

  return years.map(year => ({ value: year, label: year }));
}

function BiomassManagement({ parcel, year, photos, documents, onUpdateParcel }) {
  const {selected} = useContext(AppContext);
  const {onGetDocuments, onGetParcels, onGetPhotos} = useContext(DataContext)
  const [upload, setUpload] = useState(false);
  const [deleteDoc, setDeleteDoc] = useState(null);
  const [photosModal, setPhotosModal] = useState(false);

  const status = parcel.biomass.find(obj => obj.year.toString() === year.toString()) || {};
console.log(status)
  
  const [model, setModel] = useState({
    numberOfTreesRemoved: status.numberOfTreesRemoved || 0,
    ef: status.ef,
    amountB: status.amountB,
    energyContent: status.energyContent,
    energyContentB: status.energyContentB || 16,
    efficiency: status.efficiency || 85,
    reduction: status.reduction,
    fuel: status.fuel
  });

  const renderDocuments = () => {
    let categories = {};
    documents.map(doc => {
      if(doc.tag === 'BM' && doc.year === parseInt(year) && parcel.id === doc.parcel_id) {
        if (!categories.hasOwnProperty(doc.title)) {
          categories[doc.title] = [doc];
        } else {
          categories[doc.title].push(doc);
  
        }
  
      }
    })
    
    if(Object.keys(categories).length === 0) {
      return <Typography sx={{ mt: '20px', mb: '20px' }}>There are no uploaded documents tagged with "Biomass Management"</Typography>
    }


    let list = Object.keys(categories).map((title, index) => {
      return (
        <Grid key={index} item xs={12} sm={12} md={6} sx={{ position: 'relative' }}>
          <fieldset sx={{}}>
            <legend>{title} <Chip sx={{ position: 'absolute', right: '10px', top: '10px' }} color="warning" label={categories[title].tag || '#Biomass Management'} /></legend>
            <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
              {categories[title].map((doc, idx) => {
                return (
                  <Stack sx={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden' }} direction="row" key={idx} alignItems="center" spacing={2}>
                    <Stack direction="row" alignItems="center" spacing={2} justifyItems="space-between">
                      <IconButton component={'a'} href={doc.file} target="_blank" size="large" color="primary" ><FileOpen fontSize="large" /></IconButton>
                      <Typography title={doc.name} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', width: { xs: '200px', md: '260px' }, textOverflow: 'ellipsis' }}>{doc.name}</Typography>

                    </Stack>
                    <IconButton onClick={() => {setDeleteDoc(doc.id)}} size="large" color="error" ><Delete /></IconButton>

                  </Stack>
                )
              })}
            </Stack>
          </fieldset>
        </Grid>
      )
    })

    return <Grid container spacing={2}>{list}</Grid>;
  }


  useEffect(() => {
    if (model.amountB && model.energyContent && model.efficiency && model.ef) {
      console.log("USO")
      let reduction = $carbon.calculateBiomassReduction(model);

      setModel(current => ({ ...current, reduction: reduction }));
    } else {
      setModel(current => ({ ...current, reduction: undefined }));
    }

  }, [model.amountB, model.energyContent, model.efficiency, model.ef]);


  const onSubmit = async () => {
    try {

      if(model.reduction) {
      

        let id = parcel.biomass.find(obj => obj.year.toString() === year.toString()).id;
        
        let result = await $data.patchParcelBiomass(id, {biomass_status: [{...model, year: parseInt(year)}]});
        onGetParcels(parcel.project.id);
        onUpdateParcel();
      }
    } catch(e) {
      console.error(e);
    } finally {

    }

  }
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" fontWeight="bold">1.Orchard end-of-life information</Typography>
        <Divider />

      </Grid>
      {/* <Grid item xs={12} sm={6} md={4}>
        <SelectInput name="Year" label="Year" value={model.year} items={generateYears(parcel.history[0].year)} size="small" onChange={(e) => setModel(current => ({...current, year: e.target.value}))}/>
      </Grid> */}
      <Grid item xs={12} sm={6} md={4}>
        <TextField value={model.numberOfTreesRemoved} onChange={(e) => setModel(current => ({ ...current, numberOfTreesRemoved: e.target.value }))} fullWidth type="number" label="Number of trees removed" size="small" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" fontWeight="bold">2. Emission reductions due to replacing fossil fuels with biomass </Typography>
        <Divider />

      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField value={model.amountB} onChange={(e) => setModel(current => ({ ...current, amountB: e.target.value }))} fullWidth type="number" label="Amount of Biomass (kg)" size="small" />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <SelectInput name="Replacement of Fuel" label="Replacement of Fuel" items={Object.keys(energyContentFuels).map(fuel => ({ value: fuel, label: fuel }))} value={model.fuel} onChange={(evt) => { console.log(evt.target.value); setModel(current => ({ ...current, fuel: evt.target.value, ...energyContentFuels[evt.target.value] })) }} size="small" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Stack>
          <span>Efficiency of conversion biomass-to-energy (%)</span>
          <Slider value={model.efficiency} min={0} max={100} valueLabelDisplay="auto" onChange={(evt, val) => setModel(current => ({ ...current, efficiency: val }))} />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Typography color="info" fontWeight="bold" variant="h6">Estimated emission reduction (kg CO<sub>2</sub>): {model.reduction ? model.reduction.toFixed(1) : ' - '}</Typography>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button onClick={onSubmit} startIcon={<Save />} variant="contained"> Save result </Button>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6" fontWeight="bold">3. Provide evidence/proof of the replacement</Typography>

        <Divider />
        {Boolean(documents) && documents?.length > 0 && renderDocuments()}
        {(Boolean(!documents) || documents?.length === 0) && <Typography sx={{ mt: '20px', mb: '20px' }}>There are no uploaded documents</Typography>}

        <Stack sx={{ mt: '20px', mb: '20px' }} direction="row" alignItems="center" spacing={2}>
          <Button onClick={() => setUpload(true)} variant="contained" startIcon={<UploadFile />}>Upload document(s)</Button>
          <Button onClick={() => setPhotosModal(true)} variant="contained" startIcon={<Photo />}>Attach geo-tagged photos</Button>
        </Stack>
      </Grid>

      {upload && <UploadDocumentModal tag={'BM'} tags={[{ value: 'BM', label: 'Biomass Management' }]} open={upload} onClose={() => setUpload(false)} parcel={parcel.id} year={year} />}
      {Boolean(deleteDoc) && <DeleteDocumentModal open={Boolean(deleteDoc)} documentId={deleteDoc} onClose={() => setDeleteDoc(null)} onDeleteDocument={() => onGetDocuments(selected)} />}
      {photosModal && <CarbonPhotosModal tag={'BM'} parcelId={parcel.id} year={model.year} onRefreshPhotos={onGetPhotos} selectable projectId={parcel.project.id} open={photosModal} photos={photos} onClose={() => setPhotosModal(false)} />}
    </Grid>
  )
}

export default BiomassManagement;